var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @rushstack/security/no-unsafe-regexp */
/* eslint-disable no-constant-condition */
import React, { useContext, useEffect, useState } from 'react';
import { Absolute, Avatar, Box, ChatMessage, Flex, Link, Text } from 'pcln-design-system';
import { format } from 'date-fns';
import { VoteType } from './chatTypes';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { livePersonMessagesStatusManager } from './LivePersonService/livePersonMessageStatusManager';
import { TravelBotLogoImage } from './TravelBotLogoImage';
import VoteUp from './Assets/VoteUp';
import VoteDown from './Assets/VoteDown';
import styled from 'styled-components';
import { feedbackPost } from './utils/feedbackPost';
import analytics from './analytics';
import { motion } from 'framer-motion';
var COSTUMER_SUPPORT_NUMBER = '1-877-477-5807';
var GREETING_MESSAGE = "Hi, I'm Penny, your virtual travel assistant! How can I help you today?";
var pricelineHyperLinkRegExpPattern = /http(s)?:\/\/(www\.)?priceline\.com((\/(\w|-)+)+?)+(\/)?(\?)?(((\w)+\=(\w)+&?)?)+/;
var phoneNumberRegexPattern = /(\d-)?\d{3}-\d{3}-\d{4}/;
var boldTextRegexPattern = /\*\*(\w|\W)+\*\*/;
var regExpPatternList = [
    {
        type: 'phoneNumber',
        pattern: phoneNumberRegexPattern,
    },
    {
        type: 'hyperlink',
        pattern: pricelineHyperLinkRegExpPattern,
    },
    {
        type: 'boldText',
        pattern: boldTextRegexPattern,
    },
];
var setHyperlinkFormatInContent = function (_a) {
    var content = _a.content, regexPatternIndex = _a.regexPatternIndex;
    if (!content) {
        return [];
    }
    try {
        var _b = regExpPatternList[regexPatternIndex], type = _b.type, pattern = _b.pattern;
        var newRegExp = new RegExp(pattern, 'g');
        var previousMatchedIndex = 0;
        var finalList = [];
        while (true) {
            var result = newRegExp.exec(content);
            if (result) {
                var matchedContent = result[0];
                var index = result.index;
                var preFix = content
                    .slice(previousMatchedIndex, index + matchedContent.length)
                    .replaceAll(matchedContent, '');
                previousMatchedIndex = index + matchedContent.length;
                if (regexPatternIndex + 1 < regExpPatternList.length) {
                    var nextFormatedList = setHyperlinkFormatInContent({
                        content: preFix,
                        regexPatternIndex: regexPatternIndex + 1,
                    });
                    finalList.push.apply(finalList, __spreadArray(__spreadArray([], nextFormatedList, false), [{
                            preFix: nextFormatedList.length === 0 ? preFix : '',
                            matchedContent: matchedContent,
                            type: type,
                        }], false));
                }
                else {
                    finalList.push({
                        preFix: preFix,
                        matchedContent: matchedContent,
                        type: type,
                    });
                }
            }
            else {
                var preFix = content.slice(previousMatchedIndex);
                if (regexPatternIndex + 1 < regExpPatternList.length) {
                    var nextFormatedList = setHyperlinkFormatInContent({
                        content: preFix,
                        regexPatternIndex: regexPatternIndex + 1,
                    });
                    finalList.push.apply(finalList, nextFormatedList);
                }
                else if (preFix) {
                    finalList.push({
                        preFix: preFix,
                        matchedContent: '',
                        type: '',
                    });
                }
                break;
            }
        }
        return finalList;
    }
    catch (_) {
        return [];
    }
};
var VoteWrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var CustomChatMessage = styled(ChatMessage)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-wrap: anywhere;\n  & div:nth-child(2) {\n    width: fit-content;\n  }\n"], ["\n  overflow-wrap: anywhere;\n  & div:nth-child(2) {\n    width: fit-content;\n  }\n"
    /**
     * TravelBotChatSingleDialogGeneric
     * Support showing message content for assistan/user
     * @public
     */
])));
/**
 * TravelBotChatSingleDialogGeneric
 * Support showing message content for assistan/user
 * @public
 */
export var TravelBotChatSingleDialogGeneric = function (props) {
    var _a;
    var _b = useContext(ChatbotDataContext), logCustomerCarePhoneNumberClicked = _b.logCustomerCarePhoneNumberClicked, logCustomerCarePhoneNumberDisplayed = _b.logCustomerCarePhoneNumberDisplayed, isMobile = _b.isMobile, submitChatMessagesPayload = _b.submitChatMessagesPayload, fetchRequestOptions = _b.fetchRequestOptions;
    var message = props.message, livePersonAgentInitial = props.livePersonAgentInitial, livePersonAgentName = props.livePersonAgentName;
    var _c = submitChatMessagesPayload !== null && submitChatMessagesPayload !== void 0 ? submitChatMessagesPayload : {}, rguid = _c.rguid, cguid = _c.cguid;
    var content = message.content, role = message.role, _d = message.vote, vote = _d === void 0 ? VoteType.NONE : _d;
    var _e = useState(vote), voteStatus = _e[0], setVoteStatus = _e[1];
    var _f = useState(false), voteSubmitted = _f[0], setVoteSubmitted = _f[1];
    var isAssistant = role === 'assistant';
    var isLivePersonAgent = role === 'livePersonAgent';
    var isNotUser = isAssistant || isLivePersonAgent;
    var _g = useState([]), linesOfContents = _g[0], pushOneLineContent = _g[1];
    function phoneNumberClicked() {
        if (logCustomerCarePhoneNumberClicked && typeof logCustomerCarePhoneNumberClicked === 'function') {
            logCustomerCarePhoneNumberClicked();
        }
    }
    useEffect(function () {
        var _a, _b;
        var finalLinesOfContents = [];
        var bulletPointStartsIndex = -1;
        if (isNotUser) {
            (_b = (_a = content
                .split('\n')) === null || _a === void 0 ? void 0 : _a.filter(function (c) { return !!c; })) === null || _b === void 0 ? void 0 : _b.forEach(function (sc, i) {
                var hasBulletPointStarter = sc.startsWith('-');
                if (hasBulletPointStarter && bulletPointStartsIndex === -1) {
                    bulletPointStartsIndex = i;
                }
                var hasBulletPoint = bulletPointStartsIndex !== -1;
                var rawLineContent = hasBulletPoint && hasBulletPointStarter
                    ? sc.replace('-', "".concat(i + 1 - bulletPointStartsIndex, "."))
                    : sc;
                var oneLineContent = setHyperlinkFormatInContent({
                    content: rawLineContent,
                    regexPatternIndex: 0,
                });
                if (oneLineContent.length !== 0) {
                    finalLinesOfContents.push(oneLineContent);
                }
            });
            pushOneLineContent(finalLinesOfContents);
        }
        else {
            pushOneLineContent([
                [
                    {
                        preFix: content,
                        matchedContent: '',
                        type: '',
                    },
                ],
            ]);
        }
    }, [content]);
    var MessageIcon = function Icon(props) {
        if (isAssistant) {
            return React.createElement(TravelBotLogoImage, null);
        }
        if (isLivePersonAgent) {
            return React.createElement(Avatar, __assign({}, props, { initials: livePersonAgentInitial, color: 'primary' }));
        }
        return null;
    };
    var footerMessagePrefix = isAssistant
        ? 'Penny'
        : isLivePersonAgent
            ? livePersonAgentName
                ? ((_a = livePersonAgentName === null || livePersonAgentName === void 0 ? void 0 : livePersonAgentName.split(' ')) === null || _a === void 0 ? void 0 : _a[0]) || livePersonAgentInitial
                : 'Agent'
            : '';
    var footerMessageDateString = (message === null || message === void 0 ? void 0 : message.date) ? format(message === null || message === void 0 ? void 0 : message.date, "LLL d 'at' h:mm:ss aaa") : '';
    var messgeStatus = livePersonMessagesStatusManager.getStatusByMsgId(message.msgId);
    var handleVoteStatus = function (status) {
        setVoteStatus(status);
    };
    var handleFeedbackSubmit = function (vote, feedback) { return __awaiter(void 0, void 0, void 0, function () {
        var headers, baseUrl, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!!voteSubmitted) return [3 /*break*/, 2];
                    headers = fetchRequestOptions.headers;
                    baseUrl = '/genai-svc/genai/chat/feedback';
                    return [4 /*yield*/, feedbackPost({
                            feedback: feedback !== null && feedback !== void 0 ? feedback : '',
                            message: __assign(__assign({}, props.message), { vote: vote }),
                            conversationId: rguid,
                            cguid: cguid,
                        }, baseUrl, headers)];
                case 1:
                    _a.sent();
                    setVoteSubmitted(true);
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    analytics.log({
                        source: 'feedback error',
                        message: e_1,
                        cguid: cguid,
                        conversationId: rguid,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var showVoteUp = voteStatus === VoteType.NONE || voteStatus === VoteType.UP;
    var showVoteDown = voteStatus === VoteType.NONE || voteStatus === VoteType.DOWN;
    var isGreetingMessage = GREETING_MESSAGE === message.content;
    var voteGap = isMobile ? 4 : 3;
    var Footer = footerMessageDateString ? (React.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 } },
        React.createElement(Flex, { alignItems: 'center', justifyContent: isNotUser ? 'space-between' : 'flex-end' },
            messgeStatus && (React.createElement(Text, { color: 'text.light', textStyle: 'subheading6', mr: 2 }, messgeStatus)),
            footerMessagePrefix && (React.createElement(Absolute, { width: 0.96, top: '-10px' },
                React.createElement(Flex, { justifyContent: 'space-between', width: 1 },
                    React.createElement(Text, { color: 'text.light', textStyle: 'subheading6' },
                        footerMessagePrefix,
                        " \u00B7 ",
                        footerMessageDateString),
                    !isGreetingMessage ? (React.createElement(Flex, null,
                        showVoteUp ? (React.createElement(VoteWrapper, { mr: showVoteUp && !showVoteDown ? 0 : voteGap, onClick: function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                handleVoteStatus(VoteType.UP);
                                                return [4 /*yield*/, handleFeedbackSubmit(VoteType.UP, '')];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            } },
                            React.createElement(VoteUp, { isActive: voteStatus === VoteType.UP }))) : null,
                        showVoteDown ? (React.createElement(VoteWrapper, { onClick: function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                handleVoteStatus(VoteType.DOWN);
                                                return [4 /*yield*/, handleFeedbackSubmit(VoteType.DOWN, '')];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            } },
                            React.createElement(VoteDown, { isActive: voteStatus === VoteType.DOWN }))) : null)) : null))),
            !footerMessagePrefix && (React.createElement(Text, { color: 'text.light', textStyle: 'subheading6' }, footerMessageDateString))))) : null;
    return (React.createElement(CustomChatMessage, { mb: isNotUser ? '40px' : 4, ml: isNotUser ? '' : 'auto', variation: isNotUser ? 'initial' : 'outgoing', Icon: MessageIcon, message: React.createElement(Text, { fontSize: 2 }, linesOfContents.map(function (oneLine, lIndex) {
            oneLine.map(function (cont) {
                if (cont.type === 'phoneNumber' &&
                    cont.matchedContent === COSTUMER_SUPPORT_NUMBER &&
                    logCustomerCarePhoneNumberDisplayed &&
                    typeof logCustomerCarePhoneNumberDisplayed === 'function') {
                    logCustomerCarePhoneNumberDisplayed();
                }
            });
            var isLastLine = lIndex === linesOfContents.length - 1;
            return (React.createElement(Text, { fontSize: 2, key: "chat-content-line-".concat(lIndex), mb: isLastLine ? 0 : 2 }, oneLine.map(function (cont, cIndex) {
                return (React.createElement(React.Fragment, { key: "cont-".concat(cIndex) },
                    cont.preFix,
                    cont.type === 'phoneNumber' && (React.createElement(Link, { href: "tel:".concat(cont.matchedContent.replace(/\D/g, '')), onClick: cont.matchedContent === COSTUMER_SUPPORT_NUMBER ? phoneNumberClicked : undefined }, cont.matchedContent)),
                    cont.type === 'hyperlink' && (React.createElement(Link, { href: cont.matchedContent, title: "hyper link for ".concat(cont.matchedContent), target: '_blank' }, cont.matchedContent.length > 75
                        ? "".concat(cont.matchedContent.slice(0, 75), "...")
                        : cont.matchedContent)),
                    cont.type === 'boldText' && (React.createElement(Text.span, { bold: true }, cont.matchedContent.replace(/\*/g, '')))));
            })));
        })), footer: Footer }));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=TravelBotChatSingleDialogGeneric.js.map